import {
  Alert,
  Autocomplete,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useForumPostData } from "../../../lib/hooks";
import { GetForumPostTypes } from "../../../lib/twitterAPI";
import styles from "./../../../styles/charts/chartStyle.module.css";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { titleStyler, toShortNumber } from "../../../lib/util";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "../twitter/TwitterWordCloud";
import { desc } from "../../../lib/chartDescription";

const property_name_options = ["Likes", "Views", "Posts", "Replies"];

export default function ForumDatePropertyScatter() {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const [propertyName, setpropertyName] = useState(property_name_options[0]);
  const [startDate, setStartDate] = useState<Dayjs>(
    dayjs(new Date()).subtract(1, "month")
  );
  const [endDate, setEndDate] = useState<Dayjs>(dayjs(new Date()));

  let dateRange =
    "[" +
    startDate.format("YYYY-MM-DD").toString() +
    "," +
    endDate.format("YYYY-MM-DD").toString() +
    "]";

  const [formData, setFormData] = useState<GetForumPostTypes>({
    property_name: propertyName,
    date_range: dateRange,
  });

  useEffect(() => {
    setFormData({
      property_name: propertyName,
      date_range: dateRange,
    });
  }, [propertyName, dateRange]);

  const { loading, forumsData, error } = useForumPostData(formData);
  let data: any[] = [];
  // may need more flexbility
  let legend: string[] = ["Positive", "Neutral", "Negative"];

  // console.log(tweetsData);

  if (!loading && !error) {
    let posList: any[] = [];
    let negList: any[] = [];
    let neuList: any[] = [];
    forumsData.forEach((post: any) => {
      switch (post.sentiment) {
        case "pos":
          posList.push({
            x: post.date,
            y: post.value,
            z: post.content,
            z1: post.title,
          });
          break;
        case "neg":
          negList.push({
            x: post.date,
            y: post.value,
            z: post.content,
            z1: post.title,
          });
          break;
        case "neu":
          neuList.push({
            x: post.date,
            y: post.value,
            z: post.content,
            z1: post.title,
          });
          break;
      }
    });
    data.push(posList, neuList, negList);
  }

  let { axisTitleStyle, axisLabelStyle, markerSize } = titleStyler();
  let series: any[] = [];

  data.forEach((item, index) => {
    series.push({
      name: legend![index],
      data: item,
      type: "scatter",
    });
  });
  let title = "Forum Data Time Series Plot";

  let options = {
    chart: {
      height: 500,
      type: "scatter",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: "Date",
            headerValue: propertyName,
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
    },
    markers: {
      // size: markerSize,
      size: markerSize,
    },
    xaxis: {
      tickAmount: 10,
      type: "datetime",
      title: {
        text: "Date",
        offsetX: 0,
        offsetY: 70,
        style: axisTitleStyle,
      },
      labels: {
        style: axisLabelStyle,
      },
    },
    yaxis: {
      tickAmount: 7,
      type: "numeric",
      title: {
        text: propertyName,
        offsetY: 0,
        style: axisTitleStyle,
        offsetX: 5,
      },
      labels: {
        style: axisLabelStyle,
        formatter: toShortNumber,
      },
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    // tooltip: {
    //   shared: false,
    //   intersect: true,
    //   items: {
    //     display: "flex",
    //   },
    //   fixed: {
    //     enabled: true,
    //     position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
    //     offsetY: 30,
    //     offsetX: 60,
    //   },
    //   followCursor: true,
    //   z: {
    //     title: "Forum Content ",
    //   },
    // },
    tooltip: {
      custom: [
        function ({ dataPointIndex, w }: { dataPointIndex: any; w: any }) {
          console.log("Custom Tooltip");
          console.log(w);
          return (
            '<div class="customToolbar">' +
            "<div>Positive:" +
            w.config.series[0].data[dataPointIndex].y +
            "</div>" +
            '<span class="toolTipTitle">' +
            w.config.series[0].data[dataPointIndex].z1 +
            "</span>" +
            "<div>" +
            w.config.series[0].data[dataPointIndex].z +
            "</div>" +
            "</div>"
          );
        },
        function ({ dataPointIndex, w }: { dataPointIndex: any; w: any }) {
          console.log("Custom Tooltip");
          console.log(w);
          return (
            '<div class="customToolbar">' +
            "<div>Neutral:" +
            w.config.series[0].data[dataPointIndex].y +
            "</div>" +
            '<span class="toolTipTitle">' +
            w.config.series[1].data[dataPointIndex].z1 +
            "</span>" +
            "<div>" +
            w.config.series[1].data[dataPointIndex].z +
            "</div>" +
            "</div>"
          );
        },
        function ({ dataPointIndex, w }: { dataPointIndex: any; w: any }) {
          console.log("Custom Tooltip");
          console.log(w);
          return (
            '<div class="customToolbar">' +
            "<div>Negative:" +
            w.config.series[0].data[dataPointIndex].y +
            "</div>" +
            '<span class="toolTipTitle">' +
            w.config.series[2].data[dataPointIndex].z1 +
            "</span>" +
            "<div>" +
            w.config.series[2].data[dataPointIndex].z +
            "</div>" +
            "</div>"
          );
        },
      ],
    },
    legend: {
      horizontalAlign: "left",
      offsetX: 40,
    },
    noData: {
      text: "Loading...",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter">
          <Typography className={styles.chartHeader}>{title}</Typography>
        </div>
        <div className="horizontalCenter">
          <div className={styles.flexibleControlRow}>
            <Autocomplete
              // autoComplete
              fullWidth
              id="combo-box-demo"
              options={property_name_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              // sx={{ width: "40%" }}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: any) => {
                // setValue(newValue);
                setpropertyName(newValue);
                // console.log(newValue);
              }}
              disableClearable
              value={propertyName}
              renderInput={(params) => (
                <TextField {...params} label="Select Property" />
              )}
            />
          </div>
        </div>

        <div className="horizontalCenter">
          <div className={styles.flexibleControlRow}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={(newValue: any) => {
                  setStartDate(newValue);
                  if (endDate.isAfter(newValue.add(1, "month"), "day"))
                    setEndDate(newValue.add(1, "month"));
                }}
                renderInput={(params: any) => (
                  <TextField size="small" {...params} sx={{ width: "190px" }} />
                )}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={endDate}
                onChange={(newValue: any) => {
                  setEndDate(newValue);
                }}
                minDate={startDate}
                maxDate={startDate.add(1, "month")}
                renderInput={(params: any) => (
                  <TextField size="small" {...params} sx={{ width: "190px" }} />
                )}
              />
            </LocalizationProvider>
          </div>
        </div>

        {!error && (
          <div style={{ width: "100%", height: "100%" }}>
            <ReactApexChart
              series={series}
              options={options as unknown as ApexOptions}
              type="scatter"
            />
          </div>
        )}

        {error && (
          <div style={{ width: "100%", height: "100%" }}>
            <Alert severity="error">{error}</Alert>
          </div>
        )}

        {getChartBottomIcons(showMaxButton, setOpen)}
        {getChartInfoIcons(desc["twitter"]["dataPropertyScatter"])}
      </Paper>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
}
